export default {
  "content": "<path d=\"M10.5 6.47L9.09 7.88l4.58 4.59-4.58 4.59 1.41 1.41 6-6-6-6z\" fill=\"var(--Primary-Text-Color)\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "25",
    "height": "25",
    "viewBox": "0 0 25 25",
    "fill": "none"
  }
};